import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { TasksQueueState } from '../types'
import featureStateSelector from './featureStateSelector'

export const errorSelector = createSelector<ReduxState, TasksQueueState, string | undefined>(
  featureStateSelector,
  state => state.UIState.error
)
